// The app-wide top-bar tabs: the ones that belong to no round.
//
// `roundPrimaryNav.ts` is the same idea for a round's nav, and the two are
// deliberately separate lists rather than one gated list. A round tab points
// inside the round you're in and disappears when you leave it; a global tab
// points at the same place from everywhere. The SiteHeader appends these after
// the round's entries, so the round's own nav still reads on its own.
//
// These carry no phase visibility and no unseen dot — both of those are
// round-relative, and a form isn't.
//
// Width note: the AppBar packs the nav row right-to-left, and inside a round
// at 1440px the round's own tabs already fill it. So for an SFC admin — the
// only role these are built for — an added tab pushes the row's last entry
// (Decide) into the More overflow at 1440px and below; at 1680px and up
// everything stays inline. Funders and recommenders get no global tabs, so
// their nav is unchanged at every width.

export type GlobalNavLinkDef = {
  key: string;
  label: string;
  href: string;
};

const GLOBAL_LINKS: (GlobalNavLinkDef & { requiresSfcAdmin: boolean })[] = [
  {
    key: "application-builder",
    label: "Application Builder",
    href: "/application-builder",
    requiresSfcAdmin: true,
  },
];

export function buildGlobalNavEntries(ctx: {
  isSfcAdmin: boolean;
}): GlobalNavLinkDef[] {
  return GLOBAL_LINKS.filter(
    ({ requiresSfcAdmin }) => ctx.isSfcAdmin || !requiresSfcAdmin,
  ).map(({ key, label, href }) => ({ key, label, href }));
}
